import React, { useState } from 'react'
import {
  ChangePasswordInputWrapper,
  ChangePasswordTitle,
  ShowPasswordAndInputWrapper,
} from './ChangePasswordInput.styled'
import { PasswordInput, PasswordCheckList } from '@clickcease/cc-client-components-lib'

export type ChangePasswordInputProps = {
  title: string
  password: string
  placeholder: string
  onChange: (password: string) => void
}

export const ChangePasswordInput = ({
  title,
  password,
  onChange,
  placeholder,
}: ChangePasswordInputProps) => {
  const [showPasswordChecklist, setShowPasswordChecklist] = useState<boolean>(false)

  return (
    <ChangePasswordInputWrapper>
      <ChangePasswordTitle>{title}</ChangePasswordTitle>
      <ShowPasswordAndInputWrapper>
        <PasswordInput
          value={password}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setShowPasswordChecklist(false)}
          onFocus={() => setShowPasswordChecklist(true)}
          showCheckSign={false}
        />
        <PasswordCheckList
          show={showPasswordChecklist}
          css={{
            top: '-50px',
            left: '280px',
          }}
          password={password}
          passwordLength={8}
          positionRight={true}
        />
      </ShowPasswordAndInputWrapper>
    </ChangePasswordInputWrapper>
  )
}
